'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterDom = require('react-router-dom');

var _Loading = require('../utility/Loading');

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createAnonymousRoute = function createAnonymousRoute(_ref) {
  var redirect = _ref.redirect;

  var AnonymousRoute = function AnonymousRoute(props) {
    var Component = props.component,
        isAuthenticated = props.isAuthenticated,
        isAuthenticating = props.isAuthenticating,
        otherProps = _objectWithoutProperties(props, ['component', 'isAuthenticated', 'isAuthenticating']);

    if (isAuthenticated || localStorage.getItem('authToken')) {
      return _react2.default.createElement(_reactRouterDom.Redirect, { to: redirect });
    }

    if (isAuthenticating) {
      return _react2.default.createElement(_Loading2.default, null);
    }

    return _react2.default.createElement(_reactRouterDom.Route, _extends({}, otherProps, { component: Component }));
  };

  AnonymousRoute.propTypes = {
    component: _propTypes2.default.any.isRequired,
    isAuthenticated: _propTypes2.default.bool.isRequired,
    isAuthenticating: _propTypes2.default.bool.isRequired
  };

  return (0, _reactRedux.connect)(function (_ref2) {
    var session = _ref2.session;
    return _extends({}, session);
  })(AnonymousRoute);
};

exports.default = createAnonymousRoute;